import {
  ReferenceInput as RaReferenceInput,
  ReferenceInputProps as RaReferenceInputProps,
} from 'react-admin';

export type ReferenceInputProps = RaReferenceInputProps & {
  disableReferenceFilter?: boolean;
};

export const ReferenceInput: React.FC<ReferenceInputProps> = ({
  disableReferenceFilter,
  filter,
  ...props
}) => {
  const finalFilter = disableReferenceFilter ? filter : { groups: ['reference'], ...filter };

  return <RaReferenceInput {...props} filter={finalFilter} />;
};
